var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-card",
        {
          staticClass: "cardClassDetailForm",
          attrs: { title: "평가대상정보" },
        },
        [
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-text", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: true,
                    label: "공정",
                    name: "processName",
                  },
                  model: {
                    value: _vm.popupParam.processName,
                    callback: function ($$v) {
                      _vm.$set(_vm.popupParam, "processName", $$v)
                    },
                    expression: "popupParam.processName",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-text", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: true,
                    label: "도면",
                    name: "diagramTitle",
                  },
                  model: {
                    value: _vm.popupParam.diagramTitle,
                    callback: function ($$v) {
                      _vm.$set(_vm.popupParam, "diagramTitle", $$v)
                    },
                    expression: "popupParam.diagramTitle",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-text", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: true,
                    label: "노드",
                    name: "nodeTitle",
                  },
                  model: {
                    value: _vm.popupParam.nodeTitle,
                    callback: function ($$v) {
                      _vm.$set(_vm.popupParam, "nodeTitle", $$v)
                    },
                    expression: "popupParam.nodeTitle",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("c-table", {
        ref: "table",
        staticClass: "q-mt-sm",
        attrs: {
          title: "시나리오",
          merge: _vm.grid.merge,
          columns: _vm.grid.columns,
          data: _vm.grid.data,
          editable: _vm.editable && !_vm.popupParam.disabled,
          gridHeightAuto: true,
          isTitle: true,
          filtering: false,
          columnSetting: false,
          usePaging: false,
          hideBottom: true,
        },
        scopedSlots: _vm._u([
          {
            key: "customArea",
            fn: function ({ props, col }) {
              return [
                col.name === "customCol"
                  ? [
                      _c(_vm.imprComponent, {
                        tag: "component",
                        attrs: {
                          col: col,
                          props: props,
                          inputEditable:
                            _vm.editable && !_vm.popupParam.disabled,
                          isImmShow: true,
                          requestContentsCols: _vm.requestContentsCols,
                          tableKey: "ramHazopAssessScenarioId",
                          ibmTaskTypeCd: "ITT0000001",
                          ibmTaskUnderTypeCd: "ITTU000001",
                        },
                        on: { imprChange: _vm.imprChange },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "customArea",
                              fn: function ({ props }) {
                                return [
                                  _vm._l(
                                    _vm.customReadOnlyCols,
                                    function (item) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            key: item.key,
                                            staticClass: "col-12",
                                          },
                                          [
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                { staticClass: "col-6" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "mini-dailog-title",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "pe-7s-angle-right-circle",
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(item.label) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              props.row[item.name]
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-12 border-content-dialog",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            props.row[item.name]
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-12 border-nocontent-dialog",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s("No Data") +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    }
                                  ),
                                  _c(
                                    "q-form",
                                    { ref: "editForm" },
                                    [
                                      _c(
                                        "c-card",
                                        {
                                          staticClass:
                                            "cardClassDetailForm q-mb-sm",
                                          attrs: { title: "시나리오 정보" },
                                        },
                                        [
                                          _c(
                                            "template",
                                            { slot: "card-button" },
                                            [
                                              _c(
                                                "q-btn-group",
                                                { attrs: { outline: "" } },
                                                [
                                                  _vm.editable &&
                                                  !_vm.popupParam.disabled
                                                    ? _c("c-btn", {
                                                        attrs: {
                                                          isSubmit: _vm.isSave,
                                                          url: _vm.saveUrl,
                                                          param: [props.row],
                                                          mappingType: "PUT",
                                                          label: "저장",
                                                          icon: "save",
                                                        },
                                                        on: {
                                                          beforeAction:
                                                            function ($event) {
                                                              return _vm.saveScenario(
                                                                props.row
                                                              )
                                                            },
                                                          btnCallback:
                                                            _vm.saveScenarioCallback,
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "template",
                                            { slot: "card-detail" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                                                },
                                                [
                                                  _c("c-textarea", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.popupParam.disabled,
                                                      editable: _vm.editable,
                                                      rows: 2,
                                                      label: "현재안전보건조치",
                                                      name: "currentSafetyMeasures",
                                                    },
                                                    model: {
                                                      value:
                                                        props.row
                                                          .currentSafetyMeasures,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          props.row,
                                                          "currentSafetyMeasures",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "props.row.currentSafetyMeasures",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-6 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                                                },
                                                [
                                                  _c("c-select", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.popupParam.disabled,
                                                      editable: _vm.editable,
                                                      comboItems: _vm.riskItems,
                                                      isShowLabel: false,
                                                      anotherLabelText:
                                                        "riskInfo",
                                                      itemText: "risk",
                                                      itemValue:
                                                        "ramMatrixRiskId",
                                                      type: "edit",
                                                      name: "beforeRamMatrixRiskId",
                                                      label: "개선 전 위험도",
                                                    },
                                                    model: {
                                                      value:
                                                        props.row
                                                          .beforeRamMatrixRiskId,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          props.row,
                                                          "beforeRamMatrixRiskId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "props.row.beforeRamMatrixRiskId",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-6 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                                                },
                                                [
                                                  _c("c-select", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.popupParam.disabled,
                                                      editable: _vm.editable,
                                                      comboItems: _vm.riskItems,
                                                      isShowLabel: false,
                                                      anotherLabelText:
                                                        "riskInfo",
                                                      itemText: "risk",
                                                      itemValue:
                                                        "ramMatrixRiskId",
                                                      type: "edit",
                                                      name: "afterRamMatrixRiskId",
                                                      label: "개선 후 위험도",
                                                    },
                                                    model: {
                                                      value:
                                                        props.row
                                                          .afterRamMatrixRiskId,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          props.row,
                                                          "afterRamMatrixRiskId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "props.row.afterRamMatrixRiskId",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                                                },
                                                [
                                                  _c("c-textarea", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.popupParam.disabled,
                                                      editable: _vm.editable,
                                                      rows: 2,
                                                      label: "개선대책",
                                                      name: "improvementMeasures",
                                                    },
                                                    model: {
                                                      value:
                                                        props.row
                                                          .improvementMeasures,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          props.row,
                                                          "improvementMeasures",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "props.row.improvementMeasures",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ]
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c("div", { staticClass: "popup-bottom-bar" }, [
        _c(
          "div",
          { staticClass: "popup-bottom-bar-close" },
          [
            _c("q-btn", {
              attrs: { flat: "", color: "gray", icon: "arrow_back" },
              on: { click: _vm.closePopUps },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }